import React, { useEffect, useState,} from 'react';
import { Post } from '../components'
import { getDocs, doc, collection, query, where } from 'firebase/firestore'
import { db } from '../firebase'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const Dashboard = () => {

    const [posts, setPosts] = useState([]);
    
    useEffect(()=>{
        getPosts();
        console.log(posts)
    }, []) 

    const getPosts = async() =>{
        var temp = [];
        const querySnapshot = await getDocs(collection(db, "Posts"))
        querySnapshot.forEach((doc)=>{
            console.log(doc.data())
            temp.push(doc.data())
            console.log(temp)
            
        })
        setPosts(temp)
        console.log(posts)
    }

  return (
    <div className='dashboard'>
        <div className='title'>
            <h2>CommunityConnect.</h2>
        </div>
        <div class="mainDash">
            <div class="posts">
            <Link to='/new' style={{ 'textDecoration': 'none' }}>
                <div class="newPost" > <FontAwesomeIcon className='plus' icon={faPlus} />Make A Post </div>
            </Link>
                {posts.map((post)=>(
                    <Post post={post} postId={post.id}/>
                ))}
            </div>
            <div class="user">
                <h1>Binghamton University</h1>
                <img src="https://tse2.mm.bing.net/th?id=OIP.KgXwsPwa5xFDbqxEv2UpNwHaLY&pid=Api&P=0" alt=""/>
                <h2>Mohfasta</h2>
                <h3>2026</h3>
            </div>
        </div>
    </div>
  )
}

export default Dashboard